<script>
  import Typeform from "$lib/components/Typeform.svelte";

  export let data;
</script>

<Typeform id={data.fields.embedID} />
